import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  profile: null,
  profileCompletion: 0
};

const carrierProfileSlice = createSlice({
  name: 'carrierProfile',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setCarrierProfileLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCarrierProfileError: (state, action) => {
      state.error = action.payload;
    },
    setCarrierProfile: (state, action) => {
      state.profile = action.payload;
      state.profileCompletion = action.payload?.profileCompletion || 0;
    },
    clearCarrierProfile: (state) => {
      state.profile = null;
      state.profileCompletion = 0;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  clearError,
  setCarrierProfileLoading,
  setCarrierProfileError,
  setCarrierProfile,
  clearCarrierProfile
} = carrierProfileSlice.actions;

export default carrierProfileSlice.reducer;